import fse from 'fs-extra'
import { execa } from 'execa'

import type { PackageManager } from './types.js'

export const getPackageManager = ({
    projectDir,
}: {
    projectDir: string
}): PackageManager => {
    try {
        // Check for flag or lockfile
        let detected: PackageManager = 'npm'
        if (fse.existsSync(`${projectDir}/pnpm-lock.yaml`)) {
            detected = 'pnpm'
        } else if (fse.existsSync(`${projectDir}/yarn.lock`)) {
            detected = 'yarn'
        } else if (fse.existsSync(`${projectDir}/package-lock.json`)) {
            detected = 'npm'
        } else if (fse.existsSync(`${projectDir}/bun.lockb`)) {
            detected = 'bun'
            // } else if (await commandExists('pnpm')) {
            //     // Prefer pnpm if it's installed
            //     detected = 'pnpm'
        } else {
            // Otherwise check the execution environment
            detected = getEnvironmentPackageManager()
        }

        return detected
    } catch (ignore) {
        return 'npm'
    }
}

const getEnvironmentPackageManager = (): PackageManager => {
    const userAgent = process.env.npm_config_user_agent || ''

    if (userAgent.startsWith('yarn')) {
        return 'yarn'
    }

    if (userAgent.startsWith('pnpm')) {
        return 'pnpm'
    }

    if (userAgent.startsWith('bun')) {
        return 'bun'
    }

    return 'npm'
}

const commandExists = async (command: string): Promise<boolean> => {
    try {
        await execa(
            process.platform === 'win32'
                ? `where ${command}`
                : `command -v ${command}`
        )
        return true
    } catch {
        return false
    }
}
